export default "__VITE_ASSET__BFMPbENg__"